import React from 'react';
import styles from './RadioButtonGroup.module.sass';

const RadioButtonGroup = ({
    children
}: Props) => {
    return <div className={styles['radiobuttongroup']}>
        { children }
    </div>;
}

interface Props {
    children?: any
}

export default RadioButtonGroup;